export enum CheckboxView {
    standard = 'standard',
    inverted = 'inverted'
}
